module.exports = __webpack_public_path__ + "static/media/gabriel.2e9d7639.jpg";